import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Events} from "../../../../../framework/providers/events";
import {AdminService} from "../../../../../core/services/AdminService";

@Component({
    selector: 'app-insurance-calc',
    templateUrl: './insurance-calc.component.html',
    styleUrls: ['./insurance-calc.component.scss'],
})
export class InsuranceCalcComponent implements OnInit, OnDestroy {
    @Input()
    type = 'insurance';

    @Input()
    title;
    @Input()
    exTableData;
    @Input()
    sectionName;
    @Input()
    editFields;
    @Input()
    lastSelectedModel;

    newModel;
    model;
    colTitle;
    fieldType;
    fieldData;
    amountOfLiability;
    valuationCharge;

    opened = false;

    constructor(public events: Events, public adminService: AdminService) {
    }

    ngOnInit() {

        this.events.subscribe('onTdClick', (data) => {
            this.sectionName = data['sectionName'];
            this.model = data['model'];
            this.colTitle = data['colTitle'];
            this.fieldType = data['fieldType'];
            this.fieldData = data['fieldData'];
            this.amountOfLiability = this.model[this.fieldType['valueField']]['value'];
            // this.valuationCharge = this.fieldData['value'];
        });

        if (this.sectionName) {
            this.getNewModel(this.sectionName);
        }

        this.type = (['rate', 'durationRate'].includes(this.sectionName) ? 'rateCalc' : 'insurance')
    }

    //insurance set value
    set() {
        this.fieldData['displayName'] = (this.valuationCharge / this.amountOfLiability * 1000).toFixed(2);
        this.fieldData['value'] = (this.valuationCharge / this.amountOfLiability * 1000).toFixed(2);
        this.adminService.saveField(this.sectionName, this.model, this.fieldData, this.fieldType);
    }

    ngOnDestroy(): void {
        this.events.unsubscribe('onTdClick');
    }

    getNewModel(secName) {
        this.newModel = this.adminService.getNewModel(secName, this.exTableData);
    }

    //custom copy zone
    copyZone() {
        this.adminService.saveModel(this.newModel, this.sectionName,
            this.exTableData, "aiisstmp", null,
            {'copyZone': this.newModel['zoneFrom']['value'], 'toZoneId': this.lastSelectedModel['id']['value']})
            .subscribe((d) => {
            })
    }

    operation(op, value) {
        for (let id of this.adminService.manageModels[this.sectionName + 'MarkData']['markedRow']) {
            let model = this.adminService.manageModels[this.sectionName + 'MarkDataById'][id];
            for (let i of this.adminService.manageModels[this.sectionName + 'MarkData']['markedCol']) {
                let exValue = model[i]['value'];
                let fieldData = model[i];
                value = parseInt(value);
                exValue = parseInt(exValue);

                if (op == '+%') {
                    fieldData['value'] = exValue + ((value / 100) * exValue);
                } else if (op == '-%') {
                    fieldData['value'] = exValue - ((value / 100) * exValue);
                } else if (op == '+') {
                    fieldData['value'] = exValue + value;
                } else if (op == '-') {
                    fieldData['value'] = exValue - value;
                }
                fieldData['displayName'] = fieldData['value'];
                fieldData['edited'] = true;
                // this.adminService.saveField(this.sectionName, model, fieldData, defData[i]);
            }
        }
    }
}
